import React, { useState } from 'react';
// import FontContent from './custom/fontContent';
// import AddTheme from './AddTheme';
// import ExampleColorPicker from './exampleColorPicker';
import { SketchPicker } from 'react-color';
import reactCSS from 'reactcss';
// import ExampleColorPickerView from './exampleColorPickerView';
// import ListFont from './custom/ListFont';
import FormControl from '@material-ui/core/FormControl';
import { withStyles } from '@material-ui/core/styles';
import { InputBase } from '@material-ui/core';
import styles from './builder.module.css';
import { PlusCircleIcon } from '@heroicons/react/solid';
import {
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Switch,
  FormControlLabel,
  Typography,
  MenuItem,
  Radio,
  Button,
  Container,
  Tabs,
  Select,
  Tab,
  Box,
} from '@material-ui/core';

import CheckBox from '@material-ui/icons/CheckBox';
import ShortTextIcon from '@material-ui/icons/ShortText';
import SubjectIcon from '@material-ui/icons/Subject';
import Trash from '@material-ui/icons/Delete';
import FilterNoneIcon from '@material-ui/icons/FilterNone';
import CloseIcon from '@material-ui/icons/Close';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import axios from 'axios';
import {useHistory} from 'react-router-dom'
import Preview from './Preview';


export function AddThemeContent({ func }) {

  const [questions, setQuestions] = useState([
    {
      questionText: '',
      questionType: 'radio',
      options: [{ optionText: '' }],
      answer: false,
      answerKey: '',
      points: 0,
      open: true,
      required: false,
    },
  ]);

   func(questions); //oper state to parent Add

  const [isOpen, setIsOpen] = useState(false);

  const [templateName, setTemplateName] = useState('Untitled template');
  const [docName, setDocName] = useState('Untitled Document');
  const [docDesc, setDocDesc] = useState('Add Description');

  const router = useHistory();

  //   ============== QUESTION
  const addQuestionField = () => {
    expandCloseAll();
    setQuestions([
      ...questions,
      {
        questionText: 'Question',
        questionType: 'radio',
        options: [{ optionText: 'Option 1' }],
        open: true,
        require: false,
      },
    ]);
  };

  const changeQuestion = (text, i) => {
    var newQuestion = [...questions];
    newQuestion[i].questionText = text;
    setQuestions(newQuestion);
    console.log(newQuestion);
  };

  const addQuestionType = (i, type) => {
    let questType = [...questions];
    console.log(questType);
    questType[i].questionType = type;
    setQuestions(questType);
  };

  const copyQuestion = (i) => {
    expandCloseAll();
    let copyQuest = [...questions];
    var newQuestion = { ...copyQuest[i] };

    setQuestions([...questions, newQuestion]);
  };

  const deleteQuestion = (i) => {
    let deleteQuest = [...questions];
    if (questions.length > 1) {
      deleteQuest.splice(i, 1);
    }

    setQuestions(deleteQuest);
  };

  const requiredQuestion = (i) => {
    var reqQuestion = [...questions];
    reqQuestion[i].required = !reqQuestion[i].required;

    console.log(reqQuestion[i].required + ' ' + i);
    setQuestions(reqQuestion);
  };
  //   ============== QUESTION END

  //   ============== OPTION
  const addOption = (i) => {
    var optionOfQuestion = [...questions];
    if (optionOfQuestion[i].options.length < 5) {
      optionOfQuestion[i].options.push({
        optionText: 'Option ' + (optionOfQuestion[i].options.length + 1),
      });
    } else {
      alert('MAX option 5');
    }

    setQuestions(optionOfQuestion);
  };

  const changeOptionValue = (text, i, j) => {
    var optionQuestion = [...questions];
    optionQuestion[i].options[j].optionText = text;
    setQuestions(optionQuestion);
    console.log(optionQuestion);
  };

  const removeOption = (i, j) => {
    var removeOptionQuestion = [...questions];
    if (removeOptionQuestion[i].options.length > 1) {
      removeOptionQuestion[i].options.splice(j, 1);
      setQuestions(removeOptionQuestion);
      console.log(i + '__' + j);
    } else if (removeOptionQuestion[i].options.length === 1) {
      alert('Option Harus ADA !');
    }
  };
  //   ============== END OPTION

  //   ==============  DRAG N DROP
  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    var itemQuestion = [...questions];
    const item = reorder(
      itemQuestion,
      result.source.index,
      result.destination.index
    );
    setQuestions(item);
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };
  //   ============== END DRAG N DROP

  //   ============== EXPAND
  const expandCloseAll = () => {
    let quest = [...questions];
    for (let j = 0; j < quest.length; j++) {
      quest[j].open = false;
    }
    setQuestions(quest);
  };
  const handleExpand = (i) => {
    let quest = [...questions];
    for (let j = 0; j < quest.length; j++) {
      if (i === j) {
        quest[j].open = true;
      } else {
        quest[j].open = false;
      }
      setQuestions(quest);
    }
  };
  //   ============== END EXPAND

  //   ============== ANSWER FEEDBACK

  function setOptionAnswer(ans, qno) {
    var Questions = [...questions];

    Questions[qno].answerKey = ans;

    setQuestions(Questions);
    console.log(qno + ' ' + ans);
  }

  function setOptionPoints(points, qno) {
    var Questions = [...questions];

    Questions[qno].points = points;

    setQuestions(Questions);
    console.log(qno + ' ' + points);
  }
  function addAnswer(i) {
    var answerOfQuestion = [...questions];

    answerOfQuestion[i].answer = !answerOfQuestion[i].answer;

    setQuestions(answerOfQuestion);
  }

  function doneAnswer(i) {
    var answerOfQuestion = [...questions];

    answerOfQuestion[i].answer = !answerOfQuestion[i].answer;

    setQuestions(answerOfQuestion);
  }

  //   ============== ANSWER FEEDBACK

  // THEME LOAD
  const OpenDrawer = () => {
    setIsOpen(true);
  };

  // const [newTheme, setNewTheme] = useState({
  //   fontType: 'Poppins',
  //   paperColor: '#FFFFFF',
  //   backgroundPaperColor: '#FFFFFF',
  //   backgroundImagePaperColor: ``,
  //   questionColor: '#000000',
  //   answerColor: '#000000',
  //   stripColor:'#000000',
  //   backgroundButtonColor: '#FEFEFE',
  // });

  // const commitToDB = () => {
  //   console.log('button save diklik');
  //   const data = {
  //     templateName: templateName,
  //     docName: docName,
  //     docDesc: docDesc,
  //     questions: questions,
  //     theme: newTheme,
  //     type: 'FORMS'
  //   };
  //   console.log('post : ', data);
  //   axios
  //     .post(`http://localhost:9001/api/v1/add-template`, { ...data })
  //     .then((response, error) => {
  //       if (error) { 
  //         response.status(400).send({ message: error.err });
  //         toast.warning({ message: error.err });
  //       }
  //       if (!error) {
  //         toast.success(response.data.message);
  //         console.log(response.data.message);
  //       }
  //     });
  // };


  function questionUI() {
    return questions.map((ques, i) => (
      <Draggable key={i} draggableId={i + 'id'} index={i}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            <div className='z-0'>
              <div className=''>
                <div className=' mx-auto my-auto flex justify-center'>
                  <DragIndicatorIcon
                    style={{
                      transform: 'rotate(-90deg)',
                      color: '#DAE0E2',
                    }}
                    // fontSize='large'
                    className='text-3xl'
                  />
                </div>
                {/* div pertama */}
                <Accordion
                  onChange={() => {
                    handleExpand(i);
                  }}
                  expanded={questions[i].open}
                  className='flex-start flex-1 bg-red-400 z-0'
                >
                  {/* START SAVE EDIT  */}
                  <AccordionSummary
                    aria-controls='panel1a-content'
                    id='panel1a-header'
                    // elevation={1}
                    // style={{ width: '50%' }}
                    className='bg-purple-500 inline'
                  >
                    {!questions[i].open ? (
                      <div className=''>
                        <p className='text-sm lg:text-lg break-all'>
                          {i + 1}. {ques.questionText}
                        </p>

                        {ques.options.map((op, j) => (
                          <div key={j} className='flex flex-wrap mt-1 mb-1'>
                            <div className='flex flex-wrap'>
                              <FormControlLabel
                                className='flex flex-wrap'
                                disabled
                                control={
                                  <input
                                    type={ques.questionType}
                                    color='primary'
                                    style={{ marginRight: '3px' }}
                                    required={ques.type}
                                    className='ml-7'
                                  />
                                }
                                label={
                                  <p className='ml-2 break-all text-sm lg:text-normal'>
                                    {ques.options[j].optionText}
                                  </p>
                                }
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      ''
                    )}
                  </AccordionSummary>

                  {/* END SAVE EDIT  */}

                  <div
                    // className={styles.questionBoxes}
                    className='-mt-14'
                  >
                    <div>
                      {!ques.answer ? (
                        <AccordionDetails
                          // className={styles.addQuestion}
                          className=''
                        >
                          {/* START QUESTION */}
                          <div className=' w-full'>
                            <div className='flex items-center align-right justify-end'>
                              <p className='text-xs text-gray-300 mr-1'>
                                Tipe Pertanyaan
                              </p>
                              <Select
                                // className={styles.select}
                                displayEmpty
                                className='w-1/2 lg:w-1/3 justify-items-end '
                                style={{ color: '#5f6368', fontSize: '13px' }}
                              >
                                <MenuItem
                                  id='text'
                                  value='Text'
                                  // defaultValue
                                  onClick={() => addQuestionType(i, 'text')}
                                >
                                  {' '}
                                  <SubjectIcon
                                    style={{ marginRight: '10px' }}
                                  />{' '}
                                  Paragraph
                                </MenuItem>

                                <MenuItem
                                  id='checkbox'
                                  value='Checkbox'
                                  onClick={() => addQuestionType(i, 'checkbox')}
                                >
                                  <CheckBox
                                    style={{
                                      marginRight: '10px',
                                      color: '#70757a',
                                    }}
                                    checked
                                  />{' '}
                                  Checkboxes
                                </MenuItem>
                                <MenuItem
                                  id='radio'
                                  value='Radio'
                                  onClick={() => addQuestionType(i, 'radio')}
                                  style={{
                                    marginTop: '-7px',
                                  }}
                                >
                                  {' '}
                                  <Radio
                                    style={{
                                      marginRight: '5px',
                                      marginLeft: '-10px',
                                      color: '#70757a',
                                    }}
                                    checked
                                  />{' '}
                                  Multiple Choice
                                </MenuItem>
                              </Select>

                              {/* <select class='form-select block w-full mt-1'>
                                <option
                                  onClick={() => addQuestionType(i, 'radio')}
                                >
                                  Option 1
                                </option>
                                <option
                                  onClick={() => addQuestionType(i, 'checkbox')}
                                >
                                  Option 2
                                </option>
                              </select> */}
                            </div>
                            {/* <hr /> */}
                            <div
                              // className={styles.addQuestionTop}
                              className='bg-pink-400 flex items-center justify-between mt-7'
                            >
                              <div className='w-full'>
                                <input
                                  type='text'
                                  // className={styles.question}
                                  className='w-full p-2 outline-none border-b-2'
                                  placeholder='Question'
                                  value={ques.questionText}
                                  onChange={(e) => {
                                    changeQuestion(e.target.value, i);
                                  }}
                                />
                              </div>
                            </div>

                            {/* END QUESTION */}

                            {/* START ANSWER QUESTION */}

                            {ques.options.map((op, j) => (
                              // <div className='{styles.addQuestionBody}' key={j}>
                              <div
                                className='flex mt-3 items-center border-b-2 ml-5'
                                key={j}
                              >
                                {ques.questionType !== 'text' ? (
                                  <input
                                    type={ques.questionType}
                                    style={{ marginRight: '10px' }}
                                  />
                                ) : (
                                  <ShortTextIcon
                                    style={{ marginRight: '10px' }}
                                  />
                                )}
                                <div className='w-full'>
                                  <input
                                    type='text'
                                    //   className={styles.textInput}
                                    className='w-full outline-none rounded-md p-2'
                                    placeholder='option'
                                    value={ques.options[j].optionText}
                                    onChange={(e) => {
                                      changeOptionValue(e.target.value, i, j);
                                    }}
                                  />
                                </div>

                                {/* <CropOriginalIcon style={{ color: '#5f6368' }} /> */}

                                <IconButton
                                  aria-label='delete'
                                  onClick={() => {
                                    removeOption(i, j);
                                  }}
                                >
                                  <CloseIcon />
                                </IconButton>
                              </div>
                            ))}

                            {/* END ANSWER QUESTION */}

                            {/* START ADD QUESTION */}

                            {ques.options.length < 5 ? (
                              // <div className={styles.addQuestionBody}>
                              <div className='flex ml-5 mt-5'>
                                <FormControlLabel
                                  disabled
                                  control={
                                    ques.questionType !== 'text' ? (
                                      <input
                                        type={ques.questionType}
                                        color='primary'
                                        inputProps={{
                                          'aria-label': 'secondary checkbox',
                                        }}
                                        style={{
                                          marginLeft: '10px',
                                          marginRight: '10px',
                                        }}
                                        disabled
                                      />
                                    ) : (
                                      <ShortTextIcon
                                        style={{ marginRight: '10px' }}
                                      />
                                    )
                                  }
                                  label={
                                    <div>
                                      <Button
                                        size='small'
                                        style={{
                                          textTransform: 'none',
                                          color: '#4285f4',
                                          fontSize: '13px',
                                          fontWeight: '600',
                                        }}
                                        onClick={() => {
                                          addOption(i);
                                        }}
                                      >
                                        Add Option
                                      </Button>
                                    </div>
                                  }
                                />
                              </div>
                            ) : (
                              ''
                            )}

                            {/* END ANSWER QUESTION */}

                            {/* START ADD QUESTION */}

                            <div className='flex justify-between lg:ml-5 mt-10'>
                              {/* <div className={styles.addQuestionBottomLeft}>
                                <Button
                                  size='small'
                                  onClick={() => {
                                    addAnswer(i);
                                  }}
                                  style={{
                                    textTransform: 'none',
                                    color: '#4285f4',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                  }}
                                >
                                  {' '}
                                  <ArrowRight
                                    style={{
                                      border: '2px solid #4285f4',
                                      padding: '2px',
                                      marginRight: '8px',
                                    }}
                                  />{' '}
                                  Answer key
                                </Button>
                              </div> */}

                              <div className='bg-gray-200 w-full flex items-center justify-between lg:justify-start'>
                                <IconButton
                                  aria-label='Copy'
                                  onClick={() => {
                                    copyQuestion(i);
                                  }}
                                >
                                  <FilterNoneIcon />
                                </IconButton>
                                <IconButton
                                  aria-label='delete'
                                  onClick={() => {
                                    deleteQuestion(i);
                                  }}
                                >
                                  <Trash />
                                </IconButton>
                                <div>
                                  <span
                                    style={{
                                      color: '#5f6368',
                                      fontSize: '13px',
                                    }}
                                  >
                                    Required{' '}
                                  </span>{' '}
                                  <Switch
                                    name='checkedA'
                                    color='primary'
                                    checked={ques.required}
                                    onClick={() => {
                                      requiredQuestion(i);
                                    }}
                                  />
                                  {/* <IconButton>
                                  <MoreVert />
                                </IconButton> */}
                                </div>
                              </div>
                            </div>

                            {/* END ADD QUESTION*/}
                          </div>
                        </AccordionDetails>
                      ) : (
                        <AccordionDetails className={styles.addQuestion}>
                          <div className={styles.topHeader}>
                            Choose Correct Answer
                          </div>
                          <div>
                            <div className={styles.addQuestionTop}>
                              <input
                                type='text'
                                className={styles.question}
                                placeholder='Question'
                                value={ques.questionText}
                                disabled
                              />
                              <input
                                type='number'
                                className={styles.points}
                                min='0'
                                step='1'
                                placeholder='0'
                                onChange={(e) => {
                                  setOptionPoints(e.target.value, i);
                                }}
                              />
                            </div>

                            {ques.options.map((op, j) => (
                              <div
                                className={styles.addQuestionBody}
                                key={j}
                                style={{
                                  marginLeft: '8px',
                                  marginBottom: '10px',
                                  marginTop: '5px',
                                }}
                              >
                                <div key={j}>
                                  <div style={{ display: 'flex' }} className=''>
                                    <div className='form-check'>
                                      <label
                                        style={{ fontSize: '13px' }}
                                        onClick={() => {
                                          setOptionAnswer(
                                            ques.options[j].optionText,
                                            i
                                          );
                                        }}
                                      >
                                        {ques.questionType !== 'text' ? (
                                          <input
                                            type={ques.questionType}
                                            name={ques.questionText}
                                            value='option3'
                                            className='form-check-input'
                                            required={ques.required}
                                            style={{
                                              marginRight: '10px',
                                              marginBottom: '10px',
                                              marginTop: '5px',
                                            }}
                                          />
                                        ) : (
                                          <ShortTextIcon
                                            style={{ marginRight: '10px' }}
                                          />
                                        )}

                                        {ques.options[j].optionText}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}

                            <div className={styles.addQuestionBody}>
                              <Button
                                size='small'
                                style={{
                                  textTransform: 'none',
                                  color: '#4285f4',
                                  fontSize: '13px',
                                  fontWeight: '600',
                                }}
                              >
                                {' '}
                                {/* <AttachFile
                                  style={{
                                    fontSize: '20px',
                                    marginRight: '8px',
                                  }}
                                /> */}
                                Add Answer Feedback
                              </Button>
                            </div>

                            <div className={styles.addQuestionBottom}>
                              <Button
                                variant='outlined'
                                color='primary'
                                style={{
                                  textTransform: 'none',
                                  color: '#4285f4',
                                  fontSize: '12px',
                                  marginTop: '12px',
                                  fontWeight: '600',
                                }}
                                onClick={() => {
                                  doneAnswer(i);
                                }}
                              >
                                Done
                              </Button>
                            </div>
                          </div>
                        </AccordionDetails>
                      )}
                    </div>
                    <div>
                      {/* STAER ADD QUESTION */}
                      {!ques.answer ? (
                        // <div className={styles.questionEdit}>
                        <div className='flex justify-center'>
                          <PlusCircleIcon
                            // className={styles.edit}

                            className='text-gray-400 hover:text-primary w-14 h-14'
                            onClick={() => {
                              addQuestionField();
                            }}
                          />
                        </div>
                      ) : (
                        ''
                      )}
                      {/* END ADD QUESTION */}
                    </div>
                  </div>
                </Accordion>
              </div>
            </div>
          </div>
        )}
      </Draggable>
    ));
  }
  
  return (
    <>
      {/* <div className='bg-white overflow-hidden shadow-md rounded-lg px-4 py-4'>
        
        <div>
          <div className='px-4 bg-white flex-col justify-center items-center rounded'>
            <div className='flex flex-wrap'>
              <div className='bg-white overflow-hidden rounded-lg px-4 py-4 w-2/6'>
                <div className='px-4 bg-white flex items-center rounded'> */}
                <div className='sm:grid-cols-2 grid sm:gap-7 gap-3 mt-6'>  
              <div className='bg-white overflow-hidden shadow-md rounded-lg px-4 py-4'>
              <div className='px-4 bg-white flex-col justify-center items-center rounded'>
                
                  <DragDropContext onDragEnd={onDragEnd} className='z-0'>
                    <Droppable droppableId='droppable'>
                      {(provided, snapshot) => (
                        <div {...provided.droppableProps} ref={provided.innerRef}>
                          {questionUI()}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>

                  {/* <div className='mt-10 mb-10'>
                    <button
                      className='w-full py-3 lg:py-2 px-12 lg:px-16 text-white-500 font-semibold rounded-lg bg-primary hover:shadow-orange-md transition-all outline-none'
                      // onClick={commitToDB}
                    >
                      Save
                    </button>
                  </div> */}

                </div>
                </div>

                <div className='bg-white overflow-hidden shadow-md rounded-lg px-4 py-4'>
              <div className='px-4 bg-white flex-col justify-center items-center rounded '>

                  <div className='hidden col-span-2 lg:flex bg-white-500  w-full'>
                    <div className='z-0  w-full'>
                      <div
                        // style={getTheme.bgPaperColor}
                        className='shadow-md p-10 w-full h-auto'
                      >
                        <div>
                          <div className='bg-white-500 shadow-md p-5 rounded-md mb-5'>
                            <p className='outline-none w-full text-lg mb-3'>
                              {docName}
                            </p>
                            <p className='outline-none w-full text-xs'>{docDesc}</p>
                          </div>
                          {/* {questions.map((ques, indexQ) =>
                        ques.options.map((opt, indexOp) => ( */}
                          <Preview
                            docName={docName}
                            docDesc={docDesc}
                            allQuest={questions}
                            // paperBg={getTheme.paperColor}
                            // questionColor={getTheme.questionColor}
                            // answerColor={getTheme.answerColor}
                            // stripColor={getTheme.stripColor}
                            // fontType={getTheme.fontStylee}
                          />
                        </div>
                        {/* ))
                      )} */}
                      </div>
                    </div>
                  </div>
                  </div>
                  </div>
                  </div>

   
                {/* </div>
              </div>
          </div>
        </div>
        </div>
      </div> */}
    </>
  );
}
